import { RadioGroup, RadioGroupProps } from "@mui/material";
import AppRadio, { AppRadioProps } from "./AppRadio";
import { AppOptionType } from "@/models";
import { forwardRef, Ref } from "react";
const AppRadioGroup = forwardRef(
  (
    { radioProps = {}, value, options = [], ...otherProps }: AppRadioGroupProps,
    ref: Ref<unknown>
  ) => {
    return (
      <RadioGroup {...otherProps} value={value || ""} ref={ref}>
        {options.map((item) => (
          <AppRadio
            key={item.value}
            value={item.value}
            label={<>{item.label}</>}
            checked={value == item.value}
            {...radioProps}
          />
        ))}
      </RadioGroup>
    );
  }
);
AppRadioGroup.displayName = "AppRadioGroup";
export default AppRadioGroup;
export type AppRadioGroupProps = RadioGroupProps & {
  radioProps?: Omit<AppRadioProps, "value" | "label" | "checked" | "ref">;
  options: AppOptionType[];
};
